import { useTranslation } from 'react-i18next';
import type { MarketAsset } from '@/widgets/market-assets';
import { SearchGroupTitle } from './SearchGroupTitle';
import { SearchMarketRow } from './SearchMarketRow';

type Props = {
  assets: Array<MarketAsset>;
  baseAsset: string;
};

const SearchMarketsGroup = ({ assets, baseAsset }: Props) => {
  const { t } = useTranslation();

  if (assets.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col">
      <SearchGroupTitle>
        {t('personalAccount.globalSearch.categories.markets')}
      </SearchGroupTitle>

      <div className="flex flex-col">
        {assets.map(asset => (
          <SearchMarketRow
            key={asset.code}
            asset={asset}
            baseAsset={baseAsset}
          />
        ))}
      </div>
    </div>
  );
};

export { SearchMarketsGroup };
